import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const getExport = (file_type="pdf", level) => {
    const projectId = localStorage.getItem("project_id");
    return Request({
        method: "get",
        url: `${baseUrl}/projects/${projectId}/reports/profitAndLoss`,
        needToken: true,
        params: { file_type: file_type, level:level }
    });
};

export const get = () => {
    const projectId = localStorage.getItem("project_id");
    return Request({
        method: "get",
        url: `${baseUrl}/projects/${projectId}/reports/profitAndLoss`,
        needToken: true,
        params:{file_type: "web"}
    });
};